import { useTranslation } from "shared/hooks/useTranslation";
import { useOfflineContext } from "shared/contexts/OfflineContext";

/**
 * Disable mutation controls while offline; pair with a global {@link components/ui/OfflineBanner}.
 * Avoid per-control toasts — banner communicates state.
 */
export function useOfflineDisabled() {
    const { isOnline } = useOfflineContext();
    const { t } = useTranslation();

    const offlineTitle = t("offline.disabled.title");

    function disabledIfOffline(alreadyDisabled?: boolean): boolean {
        return Boolean(alreadyDisabled) || !isOnline;
    }

    /** Use on icon-only buttons where `title` is the only affordance */
    function optionalOfflineTitle(baseTitle?: string): string | undefined {
        if (!isOnline) return offlineTitle;
        return baseTitle;
    }

    return { isOnline, disabledIfOffline, offlineTitle, optionalOfflineTitle };
}
